/***
 *
 *   TICKET FORM
 *   In-app create-ticket entry point. Same UI as the public intake form
 *   (PublicTicketForm) — wraps it with modal cancel, success toast, and
 *   tickets refetch. The contact step is hidden: the reporter is the
 *   signed-in user, so there is nothing there to fill in.
 *
 *   PROPS
 *   categories: ticket category list
 *   category: pre-selected category id (or 'all')
 *   cancel: show cancel button that closes the modal
 *   callback: called after successful submit
 *
 **********/

import { useContext } from 'react';
import { Animate, ViewContext } from 'components/lib';
import { PublicTicketForm } from 'components/public/publicTicketForm';
import { useTranslate } from 'app/translations';
import { useQueryClient } from 'react-query';

export const TicketForm = (props) => {
    const { _t } = useTranslate();
    const viewContext = useContext(ViewContext);
    const queryClient = useQueryClient();

    function handleCancel() {
        viewContext.modal.hide(true);
    }

    function handleSuccess(res) {
        viewContext.notification.show(_t('request.success'), 'success', true, 'toast');
        viewContext.modal.hide(true);
        props.callback && props.callback(res);
        queryClient.refetchQueries('tickets');
    }

    return (
        <Animate>
            <PublicTicketForm
                categories={props.categories}
                category={props.category}
                contact={false}
                cancel={props.cancel ? handleCancel : undefined}
                callback={handleSuccess}
            />
        </Animate>
    );
};
